import { baseApi } from "api/BaseApi";
import { Option } from "api/common/types/common.types";

import {
  ProductCCPayload,
  MaintenanceCCPayload,
  LabPayload,
  ProductCC,
  MaintenanceCC,
  PcmCreatePayload,
  PcmUpdatePayload,
  PcmResponse,
  PcmData,
  LabStub,
} from "./pcm.types";

const PCM_BASE_QUERY = "/pcm";

const pcmApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPcmFormProducts: build.query<ProductCC[], ProductCCPayload>({
      query: (payload) => ({
        url: `${PCM_BASE_QUERY}/get_cc_portal_products/`,
        params: payload,
      }),
    }),

    getPcmFormLabs: build.query<Option[], LabPayload>({
      query: (payload) => ({
        url: `${PCM_BASE_QUERY}/get_cc_portal_labs/`,
        params: payload,
      }),
      transformResponse: (response: LabStub[]) =>
        response.map((lab) => ({
          label: lab.cctl_name,
          value: lab.cctl_id,
        })),
    }),

    getPcmFormMaintenances: build.query<MaintenanceCC[], MaintenanceCCPayload>({
      query: (payload) => {
        return {
          url: `${PCM_BASE_QUERY}/get_cc_portal_maintenances/`,
          params: payload,
        };
      },
    }),

    // Mutation endpoints
    createPcm: build.mutation<PcmResponse, PcmCreatePayload>({
      query: (payload) => ({
        url: `${PCM_BASE_QUERY}/create_pcm/`,
        method: "POST",
        body: payload,
      }),
    }),

    updatePcm: build.mutation<PcmResponse, PcmUpdatePayload>({
      query: (payload) => ({
        url: `${PCM_BASE_QUERY}/create_pcm/`,
        method: "PUT",
        body: payload,
      }),
    }),

    // Get PCM by rid for edit mode
    getPcmByRid: build.query<PcmData, number>({
      query: (rid) => ({
        url: `${PCM_BASE_QUERY}/${rid}/`,
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetPcmFormLabsQuery,
  useLazyGetPcmFormLabsQuery,
  useGetPcmFormMaintenancesQuery,
  useLazyGetPcmFormMaintenancesQuery,
  useGetPcmFormProductsQuery,
  useLazyGetPcmFormProductsQuery,
  useCreatePcmMutation,
  useUpdatePcmMutation,
  useGetPcmByRidQuery,
} = pcmApi;
